import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    id: 0,
    ergebnisse: [],
    anzahl: 1,
    dialogopen: false
  },
  mutations: {
    initialiseStore (state) {
      if (localStorage.getItem('handstandchallenge')) {
        this.replaceState(
            Object.assign(state, JSON.parse(localStorage.getItem('handstandchallenge')))
        )
      }
    },
    setanzahl (state, value) {
      state.anzahl = value
    },
    add (state, obj) {
      state.ergebnisse.push(obj)
      state.id++
    },
    update (state, obj) {
      const e = state.ergebnisse.find(e => e.id === obj.id)
      if (e) Vue.set(e, 'time', obj.time)
    },
    del (state, id) {
      if (!id) state.ergebnisse = []
      else {
        const row = state.ergebnisse.findIndex(e => e.id === id)
        if (row !== -1) state.ergebnisse.splice(row, 1)
      }
    }
  },
  actions: {

  }
})

store.subscribe((mutation, state) => {
  // Store the state object as a JSON string
  localStorage.setItem('handstandchallenge', JSON.stringify(state));
});

export default store
